<div
    class="bg-card  rounded-2xl p-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow border border-gray-100 dark:border-gray-800"
    (click)="navigateToDetails()"
>
    <!-- Header -->
    <!-- <div class="flex items-center justify-between mb-4">
        <h3 class="text-[#101828] dark:text-gray-100 text-sm font-semibold"></h3>
    </div> -->

     <!-- Header -->
    <div class="flex items-center justify-between mb-5 ">
        <h3 class="text-foreground  text-md font-semibold">BMI Score</h3>
        <div class="w-7 h-7 rounded-full border border-[#F5A623] flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                 stroke="#F5A623" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
        </div>
    </div>

    <!-- BMI Value -->
    <div class="flex flex-col items-center justify-center mb-2 ">
        <span class="text-3xl font-extrabold text-[#101828] dark:text-gray-100">
            {{ bmiValue | number:'1.1-1' }}
        </span>
        <span class="text-xs font-semibold mt-1" [ngClass]="{
            'text-red-500': bmiValue < 18.5 || bmiValue >= 30,
            'text-yellow-500': bmiValue >= 25 && bmiValue < 30,
            'text-green-500': bmiValue >= 18.5 && bmiValue < 25
        }">
            {{ getBMICategory(bmiValue) }}
        </span>
    </div>

    <!-- Scale Section -->
    <div class="mt-10 px-1">
        <!-- Pointer -->
        <div class="relative h-2 mb-1">
            <div
                class="absolute bottom-0 -translate-x-1/2 transition-all duration-1000 ease-out"
                [style.left]="getPointerPosition(bmiValue)"
            >
                <div class="w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[8px] border-b-[#FFB300]"></div>
            </div>
        </div>

        <!-- Gradient Bar -->
        <div class="h-2 w-full rounded-full bg-gradient-to-r from-[#E53935] via-[#FFB300] to-[#43A047]"></div>

        <!-- Range Info -->
        <div class="mt-3 text-center">
            <span class="text-[11px] text-[#667085] dark:text-gray-400">Normal: 18.5 – 24.9</span>
        </div>
    </div>
</div>
